package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminPrompt
import com.milta.feature.admin.domain.repository.AdminRepository

class ResetPromptUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(key: String): Result<AdminPrompt> = repository.resetPrompt(key)
}
